<template>
  <div class="vision">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <!-- <h3 class="text-h4 text-sm-h3 font-weight-bold">{{$route.meta.pageTitle}}</h3> -->
        <h3 class="text-h4 text-sm-h2 font-weight-bold">Vision</h3>
        <p>창립 2011년 이래 최고의 IT 서비스를 공급하는 회사로서의 입지를 구축하고 있습니다.</p>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <v-row class="align-stretch">
            <v-col cols="12" sm="4" class="d-flex align-stretch visionBox" v-for="item in cards" :key="item.title">

              <v-card class="mx-auto rounded-xl px-4" outlined align="center">
                <v-card-title class="text-h5 mt-2 mt-sm-10 font-weight-bold justify-center" >
                  {{item.title}}
                </v-card-title>
                <!-- <v-icon class="my-1 my-sm-7" large>{{item.icon}}</v-icon> -->
                <v-img :src="item.src" rel="preload" contain height="130" />
                <v-card-subtitle class="mb-2 mb-sm-10">{{item.subtitle}}</v-card-subtitle>
              </v-card>

            </v-col>
          </v-row>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'vision',
  data() {
    return {
      
      cards: [
        {
          src: require("@/assets/img_sub_comp_vision01.svg"),
          icon: 'mdi-account-group',
          title: '인재경영',
          subtitle: '기업의 가치는 기업 구성원에 의해 결정되며, 구성원의 기술/인성 배양을 핵심가치로 한다.',
        },
        {
          src: require("@/assets/img_sub_comp_vision02.svg"),
          icon: 'mdi-check-decagram',
          title: '품질경영',
          subtitle: '기업의 평판은 서비스/제품의 품질에 의해 평가되며, 업계 최고품질의 서비스/제품 공급에 역량을 집중한다.',
        },
        {
          src: require("@/assets/img_sub_comp_vision03.svg"),
          icon: 'mdi-finance',
          title: '가치경영',
          subtitle: '기업 경영의 영속성을 위한 이익구조 실현 및 주주/입직원을 위한 경영 성과 창출을 경영과제라는 자세로 임한다.',
        },
      ],
    
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".vision .sub-body-title", {
      scrollTrigger: {
        trigger: ".sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });

    gsap.from(".vision .visionBox", {
      scrollTrigger: {
        trigger: ".visionBox",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3,
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>